// extracted by mini-css-extract-plugin
export default {"download":"download-Q6nt9","button":"button-fvwza","icon":"icon-mH7vR","menu":"menu-a3Zi6"};